export default __webpack_public_path__ + "static/media/children_classroom.d7074c62.jpeg";